import classNames from 'classnames'
import {
  bool,
  node,
  number,
  object,
  oneOfType,
  shape,
  string,
} from 'prop-types'

import Price from 'views/components/atoms/Price'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { isDiscountValid } from 'views/utils/productUtils'

const getSuperScriptValue = (type, shopConfig) => {
  const superScript = {
    'discount': shopConfig?.shopSettings?.superScripts.supNoteNumber,
    'rx': shopConfig?.shopSettings?.superScripts.bonus,
  }[type]

  return superScript || null
}

const Badge = props => {
  const {
    value,
    color,
    textcolor,
    showSupNotes,
    ellipse,
    label,
    size,
    pricing,
    discount,
    supNoteNumber,
    badgeType,
    priceSymbolRight,
    className,
    dataQa,
    children,
    publicRuntimeConfig: {
      publicConfig: { discountBoundaries },
    },
  } = props
  let badgeContent = ''
  let superScriptValue =
    supNoteNumber || getSuperScriptValue(badgeType, props.shopConfig)

  if (discount) {
    // TODO remove public runtime config and shop config dependencies. They must be passed via the component props only
    superScriptValue =
      supNoteNumber ||
      props.shopConfig?.shopSettings?.superScripts.supNoteNumber

    if (!isDiscountValid(value, discountBoundaries)) {
      return null
    }
    badgeContent = <>&minus;{value}%</>
  } else {
    badgeContent = pricing ? (
      <Price amount={parseFloat(value)} symbolRight={priceSymbolRight} />
    ) : (
      value
    )
  }

  const classname = classNames(
    className,
    `a-Badge u-background-color--${color}`,
    {
      'a-Badge--ellipse': ellipse,
      [`a-Badge--size-${size}`]: !pricing && !ellipse,
      'a-Badge-discount__text': discount,
    }
  )

  const badgeLabel =
    label && !ellipse ? (
      <span className="a-Badge__label a-Badge__label--smaller u-display--block">
        {label}
      </span>
    ) : (
      ''
    )
  const classNameBadgeLabel = badgeLabel
    ? classNames('a-Badge__label u-display--block')
    : ''

  const classnameBadge = classNames(
    'a-Badge__inner u-transform-center u-text-align--center',
    `u-color--${textcolor}`
  )

  return (
    <div className={classname} data-qa-id={dataQa}>
      <div className={classnameBadge}>
        <div className={classNameBadgeLabel}>
          {badgeContent}
          {children}
          {showSupNotes && <sup>{superScriptValue}</sup>}
        </div>
        {badgeLabel}
      </div>
    </div>
  )
}

Badge.propTypes = {
  value: oneOfType([string, object, number]),
  label: oneOfType([string, object]),
  ellipse: bool,
  textcolor: string,
  color: string,
  size: string,
  badgeType: string,
  className: string,
  showSupNotes: bool,
  pricing: bool,
  discount: bool,
  priceSymbolRight: bool,
  supNoteNumber: string,
  dataQa: string,
  children: node,
  publicRuntimeConfig: shape({}),
  shopConfig: shape({}),
}

Badge.defaultProps = {
  value: '',
  label: '',
  ellipse: false,
  color: 'blue',
  badgeType: null,
  textcolor: 'white',
  size: 'medium',
  className: '',
  discount: false,
  showSupNotes: false,
  pricing: false,
  supNoteNumber: '',
  priceSymbolRight: false,
  dataQa: undefined,
  children: undefined,
  publicRuntimeConfig: {},
  shopConfig: {},
}

export default withShopAndRuntimeConfig(Badge)
